module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/terminals/terminals.component.scss
// module id = ./src/app/routes/terminals/terminals.component.scss
// module chunks = 9